import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import RevenueIntelligence from "./pages/RevenueIntelligence";
import CTALibrary from "./pages/CTALibrary";
import Benchmark from "./pages/Benchmark";
import RateCard from "./pages/RateCard";
import Negotiation from "./pages/Negotiation";
import NegotiationEditor from "./pages/NegotiationEditor";
import SitesList from "./pages/SitesList";
import SiteDetail from "./pages/SiteDetail";
import { StudiesList, StudyDetail } from "./pages/Studies";
import Labor from "./pages/Labor";
import Uploads from "./pages/Uploads";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import AuthGate from "./components/AuthGate";
import { TourProvider } from "./components/TourContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <TourProvider>
          <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/change-password" element={<AuthGate><ChangePassword /></AuthGate>} />
          <Route path="/" element={<AuthGate><RevenueIntelligence /></AuthGate>} />
          <Route path="/operations" element={<AuthGate><Dashboard /></AuthGate>} />
          <Route path="/cta" element={<AuthGate><CTALibrary /></AuthGate>} />
          <Route path="/benchmark" element={<AuthGate><Benchmark /></AuthGate>} />
          <Route path="/rate-card" element={<AuthGate><RateCard /></AuthGate>} />
          <Route path="/negotiation" element={<AuthGate><Negotiation /></AuthGate>} />
          <Route path="/negotiation/:id" element={<AuthGate><NegotiationEditor /></AuthGate>} />
          {/* Legacy redirect — the standalone Contract Review tab was merged into the Negotiation editor */}
          <Route path="/contract-review" element={<Navigate to="/negotiation" replace />} />
          <Route path="/sites" element={<AuthGate><SitesList /></AuthGate>} />
          <Route path="/sites/:id" element={<AuthGate><SiteDetail /></AuthGate>} />
          <Route path="/studies" element={<AuthGate><StudiesList /></AuthGate>} />
          <Route path="/studies/:id" element={<AuthGate><StudyDetail /></AuthGate>} />
          <Route path="/labor" element={<AuthGate><Labor /></AuthGate>} />
          <Route path="/uploads" element={<AuthGate><Uploads /></AuthGate>} />
          <Route path="/reports" element={<AuthGate><Reports /></AuthGate>} />
          <Route path="/settings" element={<AuthGate><Settings /></AuthGate>} />
        </Routes>
        </TourProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
